import React from "react";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import {
  getRegistration,
  sendCrewQuantityRequest,
  submitCrewQuantityForApproval,
  updateRegistrationProfile
} from "../../../services/api/registrations";
import { Trans } from "react-i18next";
import { buildGridForRegistration } from "../../../libs/registrationUtils";
import { Link } from "react-router-dom";
import HotTable from "../../vendor/handsontable/react-handsontable.jsx";
import {
  ajaxErrorHandler,
  defaultCrewProps,
  defaultSuccess
} from "../../../libs/utils";
import Confirm from "../../../base/Confirm";

class CompanyCrewPlanning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      currentSelection: {},
      rows: [],
      columns: [],
      registration: {},
      isSubmitting: false
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._reopenPlanning = this._reopenPlanning.bind(this);

    this.reasonRef = React.createRef();
    this.tableRef = React.createRef();
  }

  static propTypes = {
    ...defaultCrewProps
  };

  UNSAFE_componentWillMount() {
    buildGridForRegistration(this.props.registration).then(grid => {
      this.setState({
        ...grid
      });
    });
  }

  _reopenPlanning() {
    Confirm(
      "Are you sure you want to re-request your crew planning for the festival days? This will lock your system until it is approved again. \n\nWe only limit the amount of crew during show days. You are always able to schedule crew on buildup or breakdown days.",
      {
        title: "Re-Request Planning - Please Confirm",
        confirmStyle: "btn-danger",
        confirmText: "Re-Request"
      }
    )
      .then(_ =>
        sendCrewQuantityRequest(this.props.registration.id, {
          sendWelcomeMails: false
        })
      )
      .then(response => {
        defaultSuccess(
          "Your registration has been reopened. The page will now refresh."
        );
        window.location.reload();
      })
      .catch(ajaxErrorHandler);
  }

  _handleSubmit(e, send = false) {
    e.preventDefault();

    this.setState({
      isSubmitting: true
    });

    const { registration, data } = this.state;
    const tableData = this.tableRef.current.hotInstance.getData();

    let promisses = [];

    registration.registrationProfiles.forEach((regProfile, colIndex) => {
      const profile = {
        amountPerDay: [],
        profileId: regProfile.profile.id
      };

      data.forEach((row, rowIndex) => {
        profile.amountPerDay.push({
          day: row.day,
          amount: tableData[rowIndex][colIndex]
        });
      });

      promisses.push(
        updateRegistrationProfile(registration.id, regProfile.id, profile)
      );
    });

    Promise.all(promisses).then(() => {
      if (send) {
        submitCrewQuantityForApproval(registration.id, {
          reason: this.reasonRef.current.value
        }).then(response => {
          getRegistration(registration.id, {
            include: "registration-profiles,registration-profiles.profile"
          }).then(registration => {
            this.setState({
              isSubmitting: false,
              registration
            });
          });
        });
      } else {
        this.setState({
          isSubmitting: false
        });
      }
    });
  }

  render() {
    const {
      isSubmitting,
      registration,
      columns,
      data,
      rowHeaders,
      colHeaders
    } = this.state;

    return [
      <AdminSubHeader
        title="Crew - Planning"
        key="subheader"
        breadcrumbs={[]}
      />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-md-12">
            <form className="m-form">
              <div className="m-portlet">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <span className="m-portlet__head-icon">
                        <i className="flaticon-line-graph" />
                      </span>
                      <h3 className="m-portlet__head-text">Planning</h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  {/* Verzonden naar company */}
                  {registration &&
                    registration.status &&
                    registration.status.name === "crewQuantityRequested" && (
                      <div>
                        <div className="alert alert-primary">
                          <Trans>crewcountMsg</Trans>
                        </div>
                        <div className="form-group m-form__group">
                          {this.state.columns.length > 0 && (
                            <HotTable
                              root="catering"
                              data={data}
                              colHeaders={colHeaders}
                              rowHeaders={rowHeaders}
                              columns={columns}
                              preventOverflow="horizontal"
                              stretchH="all"
                              rowHeaderWidth={100}
                              height={35 + data.length * 32 + 5}
                              ref={this.tableRef}
                              fillHandle={{
                                autoInsertRow: false
                              }}
                            />
                          )}
                        </div>
                        <div className="form-group m-form__group">
                          <label htmlFor="planningRemark">Extra Remarks</label>
                          <textarea
                            className="form-control m-input"
                            id="planningRemark"
                            rows="5"
                            ref={this.reasonRef}
                          />
                          <span className="m-form__help">
                            If you're requesting a lot more crew than last year,
                            it might be a good idea to give us some explanation
                          </span>
                        </div>
                      </div>
                    )}

                  {/* Verzonden naar TML */}
                  {registration &&
                    registration.status &&
                    (registration.status.name ===
                      "crewQuantityWaitingForApproval" ||
                      registration.status.name === "approved") && (
                      <div>
                        {registration.status.name ===
                          "crewQuantityWaitingForApproval" && (
                          <div className="alert alert-success">
                            <Trans>crewcountMsgSubmitted</Trans>
                          </div>
                        )}

                        {registration.status.name === "approved" && (
                          <div
                            className="m-alert m-alert--icon m-alert--outline alert alert-success"
                            role="alert"
                          >
                            <div className="m-alert__icon">
                              <i className="la la-warning" />
                            </div>
                            <div className="m-alert__text">
                              <Trans>crewcountMsgApproved</Trans>
                            </div>
                            <div className="m-alert__actions">
                              <button
                                type="button"
                                className="btn btn-outline-brand btn-sm m-btn m-btn--pill m-btn--wide m--margin-right-10"
                                onClick={this._reopenPlanning}
                              >
                                Re-request Planning
                              </button>
                              <Link
                                to="/crew/crewmembers"
                                className="btn btn-success btn-sm m-btn m-btn--pill m-btn--wide"
                                data-dismiss="alert"
                                aria-label="Close"
                              >
                                Manage Crew
                              </Link>
                            </div>
                          </div>
                        )}
                        <div className="form-group m-form__group">
                          <table className="table m-table m-table--head-separator-primary">
                            <thead>
                              <tr>
                                <th>
                                  <Trans>Day</Trans>
                                </th>
                                {colHeaders.map(col => (
                                  <th key={col}>{col}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((row, rowIndex) => (
                                <tr key={"row_" + rowIndex}>
                                  <td>{rowHeaders[rowIndex]}</td>
                                  {columns.map((col, colIndex) => (
                                    <td key={rowIndex + "_" + colIndex}>
                                      {data[rowIndex][col.data]}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        {registration.status.reason !== "" && (
                          <div className="form-group m-form__group">
                            <label htmlFor="planningRemark">
                              Extra Remarks
                            </label>
                            <p>{registration.status.reason}</p>
                          </div>
                        )}
                      </div>
                    )}
                </div>
                {registration &&
                  registration.status &&
                  registration.status.name === "crewQuantityRequested" && (
                    <div className="m-portlet__foot">
                      <div className="row align-items-center">
                        <div className="col-lg-12 m--align-right">
                          <button
                            className={
                              "btn m-btn btn-secondary" +
                              (isSubmitting
                                ? " m-btn--custom m-loader m-loader--light m-loader--left"
                                : "")
                            }
                            disabled={isSubmitting}
                            onClick={this._handleSubmit}
                          >
                            Save draft
                          </button>{" "}
                          <button
                            className={
                              "btn m-btn btn-primary" +
                              (isSubmitting
                                ? " m-btn--custom m-loader m-loader--light m-loader--left"
                                : "")
                            }
                            disabled={isSubmitting}
                            onClick={e => this._handleSubmit(e, true)}
                          >
                            Submit planning for review.
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </form>
          </div>
        </div>
      </div>
    ];
  }
}

export default CompanyCrewPlanning;
